<template>
  <div class="flex items-center">
    {{ params.value }}&nbsp;&nbsp;
    <feather-icon icon="CrosshairIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
  </div>
</template>

<script>
const axios = require('axios').default;
import _ from 'lodash';
export default {
  name: 'CellRendererCredit',
  methods: {
    editRecord () {
        axios({
            method: "get",
            url: "https://api.xxmac.co/api/getbalance/"+this.params.data.key       
        }).then(async response => {
          if (response.data && response.data.status) {
            const data = response.data;
            data.key = this.params.data.key;
            for(const x in this.params.data.web){
              if(data[x]){
                data[x].code = this.params.data.web[x].code;
              }
            }
            //this.$store.dispatch('userManagement/fetchUsers').catch(err => { console.error(err) })
            this.$store.commit('userManagement/SET_CREDIT', data);
            this.$store.commit('userManagement/SET_OLD_CREDIT', _.cloneDeep(data));
            this.$store.commit('userManagement/SET_POPUPCREDIT', true);
          }
        });
    }
  }
}
</script>
